export default __webpack_public_path__ + "static/bg-tech-nation--mobile-ec4bc06b2fb8e30b2c9de88680cca503.webp";